import * as Yup from "yup";

export const schema = Yup.object().shape({
  unitPrice: Yup.number().when("monetizationStatus", {
    is: true,
    then: Yup.number()
      .required("Transaction amount is required")
      .min(1, "Valor mayor a 0"),
    otherwise: Yup.number(),
  }),
  monetizationStatus: Yup.boolean(),
});

interface FormValues {
  unitPrice: number;
  monetizationStatus: boolean;
}

export const initialValues: FormValues = {
  unitPrice: 0,
  monetizationStatus: true,
};
